module.exports = __webpack_public_path__ + "static/media/FramePuzzlePrizes22.9a907a05.png";